import { OffsetDateTime } from "@js-joda/core";
import BloodGlucoseFormContext from "./BloodGlucoseFormContext";
import Exercise from "./Exercise";
import Medication from "./Medication";
import QuickCheckReason from "./QuickCheckReason";

export type BloodGlucoseForm = {
  id: string;
  dateTime: OffsetDateTime;
  context: BloodGlucoseFormContext;
  exercise?: Exercise;
  carbsInGrams?: number;
  fatInGrams?: number;
  proteinInGrams?: number;
  mealContents?: string;
  medications?: Medication[];
  notes?: string;
  reasons?: QuickCheckReason[];
  readingId?: string;
};

export type BloodGlucoseFormApiDto = {
  id: string;
  dateTime: string;
  context: BloodGlucoseFormContext;
  exercise?: Exercise;
  carbsInGrams?: number;
  fatInGrams?: number;
  proteinInGrams?: number;
  mealContents?: string;
  medications?: Medication[];
  notes?: string;
  reasons?: QuickCheckReason[];
  readingId?: string;
};

export const toBloodGlucoseForm = (dto: BloodGlucoseFormApiDto): BloodGlucoseForm => ({
  ...dto,
  dateTime: OffsetDateTime.parse(dto.dateTime),
});
